// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutHeader-EmptyIconLabel_cls1__mJD9n","cls2":"PayoutHeader-EmptyIconLabel_cls2__w8jTB PayoutHeader-EmptyIconLabel_cls1__mJD9n"};